<template>

    <table v-if="show_table && state.aliases.length > 0" class="min-w-full divide divide-gray-300 mb-8">
        <thead class="bg-gray-50">
            <tr>
                <th scope="col" class="py-2 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Name</th>
                <th scope="col" class="px-3 py-2 text-left text-sm font-semibold text-gray-900">Code</th>
                <th scope="col" class="relative py-2 pl-3 pr-4 sm:pr-6"></th>
            </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
            <tr v-for="alias in state.aliases" :key="alias.temp_id">
                <td class="whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{ alias.name || '-' }}</td>
                <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500">{{ alias.code || '-' }}</td>
                <td class="relative whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <button v-on:click="() => removeAlias(alias.temp_id)" class="relative inline-flex items-center justify-end rounded-br-lg border border-transparent py-0 text-sm font-medium text-gray-500 hover:text-red-700">
                        <TrashIconFill class="h-4 w-4" />
                        <span class="ml-3">Remove</span>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>

    <Button :onClick="() => state.modal_active = true" type="button" color="blue-100" width="w-auto">Add alias</Button>

    <Modal :active="state.modal_active" size="md">
        <div class="mb-12">
            <div class="mt-3 text-center sm:mt-5">
                <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">Add an Alias</DialogTitle>
                <div class="mt-8 text-left">
                    <FormField :field="form.alias.fields.name" namespace="add_alias" :name="'name'" class="mb-1" />
                    <span class="block mb-4 text-xs text-gray-500">For example, if this their Infomart ID, type <em>'Infomart'</em></span>
                    <FormField :field="form.alias.fields.code" namespace="add_alias" :name="'code'" class="mb-4" />
                </div>
            </div>
        </div>
        <div class="">
            <Button :onClick="addAlias" type="button" color="blue" class="mb-2">Add</Button>
            <Button v-if="true" type="button" color="text-blue" v-on:click="state.modal_active = false">Cancel</Button>
        </div>
    </Modal>
</template>

<script>
import { reactive, watch, computed } from 'vue'
import { DialogTitle } from '@headlessui/vue'
import { useSystemStore } from '@sto/system.store'
import TrashIconFill from "@ico/TrashIconFill.vue";

export default {
    components: {
        TrashIconFill,
        DialogTitle
    },
    props: ['show_table', 'save_new', 'refresh'],
    setup(props, {emit}) {

        const SYSTEM_STORE = useSystemStore()

        const state = reactive({
            modal_active: false,
            aliases: []
        })

        const form = {
            alias: {
                fields: {
                    name: {
                        active: true,
                        label: 'Alias name',
                        type: 'text',
                        value: '',
                        placeholder: 'Optional',
                        stored_value: '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    code: {
                        active: true,
                        label: 'Alias code',
                        type: 'text',
                        value: '',
                        placeholder: 'Optional',
                        stored_value: '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    }
                }
            }
        }

        const closeModal = () => {
            state.modal_active = false
        }

        const resetForm = () => {
            form.alias.fields.code.value = ''
            form.alias.fields.name.value = ''
        }

        // template for an alias
        function Alias(name = '', code = '') {
            this.name = name
            this.code = code
            this.temp_id = Date.now()
        }

        const addAlias = () => {

            if (!form.alias.fields.name.value && !form.alias.fields.code.value) {
                return SYSTEM_STORE.addError('Missing Information', 'Please complete at least one of the fields')
            }

            if (props.save_new) {


                SYSTEM_STORE.addSuccess('Alias saved')

            } else {
                state.aliases.push(new Alias(
                    form.alias.fields.name.value,
                    form.alias.fields.code.value
                ))
            }

            resetForm()
            closeModal()
        }

        const removeAlias = temp_id => {
            state.aliases = state.aliases.filter(a => a.temp_id != temp_id)
            SYSTEM_STORE.addSuccess('Alias removed')
        }

        watch (
            () => state.modal_active,
            () => {
                resetForm()
            }
        )

        watch(
            () => state.aliases.length,
            (new_value) => {
                if (!Array.isArray(state.aliases) || state.aliases.length === 0) return emit('value_update', '')

                // all this fuss is necessary
                let aliases_temp = JSON.stringify(state.aliases)
                aliases_temp = JSON.parse(aliases_temp)
                aliases_temp.forEach(alias => {
                    delete alias.temp_id
                })
                emit('value_update', JSON.stringify(aliases_temp))
            }
        )

        return {
            state,
            form,
            addAlias,
            removeAlias
        }
    }
}
</script>